import { Component } from "solid-js";

interface KidsIconProps {
  class?: string;
}

export const KidsIcon: Component<KidsIconProps> = (props) => {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class={props.class}
    >
      <path
        d="M21.1876 14.47C20.8156 14.9558 20.2427 15.2458 19.631 15.2584C19.0205 15.2424 18.4495 14.953 18.0757 14.47"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.9245 14.47C13.5527 14.9554 12.9804 15.2454 12.3691 15.2584C11.7583 15.2424 11.1869 14.953 10.8125 14.47"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16 27.1153C21.006 27.1129 25.3922 23.7633 26.7125 18.9346C28.2081 18.7716 29.3411 17.5085 29.3411 16.004C29.3411 14.4995 28.2081 13.2364 26.7125 13.0735C25.3956 8.2421 21.0076 4.89014 16 4.89014C10.9924 4.89014 6.60447 8.2421 5.28756 13.0735C3.7919 13.2364 2.65894 14.4995 2.65894 16.004C2.65894 17.5085 3.7919 18.7716 5.28756 18.9346C6.60785 23.7633 10.9941 27.1129 16 27.1153Z"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.9639 20.011C17.2657 21.4926 14.7344 21.4926 13.0361 20.011"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.5181 9.58533C14.9486 9.89938 15.4671 10.0697 16 10.0722C17.4096 10.0402 18.5356 8.88839 18.5356 7.47845C18.5356 6.06852 17.4096 4.91667 16 4.8847"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
